import type { TrimViewFormData } from "@dealer-center/inventory-pages-gvm-interface";
import { useSearchParams } from "react-router-dom";
import { PagesGvmUi } from "../index";

function trimFromQueryParams(queryParams: URLSearchParams): TrimViewFormData {
  if (queryParams.size === 0) {
    return { editingTrim: false };
  }

  return {
    editingTrim: queryParams.has("id"),
    locale: queryParams.get("locale")?.toUpperCase() ?? "US_EN",
    trimId: queryParams.get("id") ?? ""
  };
}

export const TrimWrapperPage = () => {
  const [searchParams] = useSearchParams();
  const editTrim = trimFromQueryParams(searchParams);

  return <PagesGvmUi editTrim={editTrim} />;
};
